import { Stack, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  minHeight: '100%',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
  marginBottom: theme.spacing(5),
  [theme.breakpoints.down('desktop')]: {
    fontSize: 28,
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    lineHeight: 1.5,
  },
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));
